import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  Modal,
  ModalInner,
  Stack,
  Typography,
} from '@pflegenavi/web-components';

interface DirectDebitConfirmRedirectWarningProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleContinue: () => void;
  submitting: boolean;
}

export const DirectDebitConfirmRedirectWarning: FC<
  DirectDebitConfirmRedirectWarningProps
> = ({ open, setOpen, handleContinue, submitting }) => {
  const { t } = useTranslation();
  const handleClose = (_: any, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };
  return (
    <Modal open={open} handleClose={handleClose}>
      <ModalInner>
        <Card
          sx={{
            width: 600,
            p: 2,
          }}
        >
          <Stack
            sx={{
              gap: 3,
            }}
          >
            <Stack
              sx={{
                gap: 1,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                }}
              >
                {t('mangopay.direct-debit.setup.redirect-information-title')}
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: 16.5,
                }}
              >
                {t(
                  'mangopay.direct-debit.setup.redirect-information-step-away'
                )}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              sx={{
                justifyContent: 'flex-end',
                gap: 1,
              }}
            >
              <Button variant="outlined" onClick={() => setOpen(false)}>
                {t('mangopay.direct-debit.setup.redirect-cancel-button')}
              </Button>
              <Button
                type="submit"
                loading={submitting}
                onClick={handleContinue}
                variant="contained"
              >
                {t('mangopay.direct-debit.setup.redirect-continue-button')}
              </Button>
            </Stack>
          </Stack>
        </Card>
      </ModalInner>
    </Modal>
  );
};
